module.exports = {"610328100":"城关镇","610328101":"崔家头镇","610328102":"南寨镇","610328103":"张家塬镇","610328104":"水沟镇","610328105":"草碧镇","610328107":"高崖镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610328.json
// module id = 2594
// module chunks = 0